export default __webpack_public_path__ + "static/media/Background2.27eda366.png";